import { Providers } from "@microsoft/mgt-element";

export async function getBackendToken() {
  const token = await Providers.globalProvider.getAccessToken({
    scopes: [`api://${process.env.REACT_APP_BACKEND_CLIENT_ID}/access_as_user`],
  });
  return token;
}